import { Prompt } from "@/interfaces";

export type PromptKind = "ALL" | "STATIC" | "DYNAMIC";

export const isDynamicPrompt = (p: Pick<Prompt, "deliveryMode">) => p.deliveryMode === "DYNAMIC";

export const filterByKind = <T extends Pick<Prompt, "deliveryMode">>(list: T[], kind: PromptKind): T[] => {
  if (kind === "DYNAMIC") return list.filter(isDynamicPrompt);
  if (kind === "STATIC") return list.filter(p => !isDynamicPrompt(p));
  return list;
};

export const isLibraryVisible = (p: Pick<Prompt, "deliveryMode">) =>
  p.deliveryMode === "LIBRARY" || p.deliveryMode === "DYNAMIC";
